import React from "react";
import { GetwaySelectContainer } from "./style.js";
import { getewaysData } from "constants/getewaysData";
const GetwaySelect = ({ gateways, selected, setGeteway }) => {
  if (gateways.length <= 1) return null;
  return (
    <GetwaySelectContainer>
      <h5>پرداخت انلاین از درگاه:</h5>
      <div className="notice">
        قابل پرداخت از طریق کلیه کارت های بانکی عضو شبکه شتاب
      </div>
      {gateways.map((gateway) => (
        <div
          className={`item ${selected === gateway ? "selected" : ""}`}
          key={gateway}
          onClick={() => setGeteway(gateway)}
        >
          <img
            src={`/getways/${getewaysData[gateway].logo}`}
            alt={getewaysData[gateway].title}
          />
        </div>
      ))}
    </GetwaySelectContainer>
  );
};
export default GetwaySelect;
